<div class="componentdiv">
    <h1>Reset password</h1>
  
    <form [formGroup]="loginForm" #formDir="ngForm">
        <div *ngIf="!changeSuccessful">
          <div class="form-group">
            <mat-form-field class="loginfield">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Your email" value="" formControlName="email" name="email" required autocomplete="email" [(ngModel)]="form.email"> 
          
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                  <div class="error" *ngIf="email.errors.required">Email is required.</div>
                </div>
          
              </mat-form-field>
          </div>
    
              <div class="form-group">
                <mat-form-field class="loginfield">
                  <mat-label>New Password</mat-label>
                  <input matInput [type]="hide_new ? 'password' : 'text'" placeholder="New Password" id="newpassword" formControlName="newpassword" class="form-control" name= "newpassword" required [(ngModel)]="form.newpassword">
                  <mat-icon matSuffix (click)="hide_new = !hide_new">{{hide_new ? 'visibility_off' : 'visibility'}}</mat-icon>
      
                  <div *ngIf="newpassword.invalid && (newpassword.dirty || newpassword.touched)" class="alert alert-danger">
                    <div class="error" *ngIf="newpassword.errors.required">Password is required.</div>
                    <div class="error" *ngIf="newpassword.errors.minlength">Password must be at least 6 characters long.</div>
                  </div>
      
                </mat-form-field>
              </div>
                  
              <div class="form-group">
                <mat-form-field class="loginfield">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput [type]="hide_confirm ? 'password' : 'text'" placeholder="Confirm Password" id="confirmpassword" formControlName="confirmpassword" class="form-control" name= "confirmpassword" required [(ngModel)]="form.confirmpassword">
                  <mat-icon matSuffix (click)="hide_confirm = !hide_confirm">{{hide_confirm ? 'visibility_off' : 'visibility'}}</mat-icon>
      
                  <div *ngIf="confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched)" class="alert alert-danger">
                    <div class="error" *ngIf="confirmpassword.errors.required">Password is required.</div>
                    <div class="error" *ngIf="confirmpassword.errors.minlength">Password must be at least 6 characters long.</div>
                    <div class="error" *ngIf="confirmpassword.errors.confirmedValidator">New password and Confirm password must match.</div>
                  </div>
      
                </mat-form-field>
              </div>
              <br/><br/>
          <div class="error" *ngIf="changeFailed"><br/>{{errorMessage}}</div>
        </div>
        <div *ngIf="changeSuccessful"><br/>You have successfully changed your password. You can now log in again.</div>
<mat-toolbar class="bottom-toolbar">
          <button mat-raised-button color="primary" type="button" class="btn btn-default" (click)="onClick()"
               [disabled]="!loginForm.valid">Save</button>
</mat-toolbar>
    </form>

</div>
